import { ChangeDetectionStrategy, Component, forwardRef, input, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { MarketingTouchesService } from 'src/app/api/caching/marketing-touches.service';
import { MarketingTouch } from 'src/app/api';
import { UiModule } from "../../ui.module";
import { TagModule } from 'primeng/tag';
import { IconService } from '../../icon.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-marketing-touches-dropdown-multi',
  templateUrl: './marketing-touches-dropdown-multi.component.html',
  styleUrl: './marketing-touches-dropdown-multi.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MultiSelectModule, UiModule, TagModule, CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MarketingTouchesDropdownMultiComponent),
      multi: true
    }
  ],
})
export class MarketingTouchesDropdownMultiComponent implements ControlValueAccessor, OnInit {

  value: MarketingTouch[] | null = null;
  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;
  touched = false;

  form = new FormGroup({
    marketingTouches: new FormControl<MarketingTouch[]>([])
  });

  private _options: MarketingTouch[] = [];
  @Input() set options(value: MarketingTouch[]) {
    this._options = value ?? [];
  }
  get options(): MarketingTouch[] {
    return this._options;
  }

  virtualScroll = input(false)
  virtualScrollItemSize = input(38)

  constructor(
    private marketingTouchesService: MarketingTouchesService,
    public icons: IconService
  ) { }

  ngOnInit(): void {
    if (this._options.length === 0) {
      this.marketingTouchesService.getAllMarketingTouches().subscribe((touches: MarketingTouch[]) => {
        this._options = touches;
      });
    }
    this.form.valueChanges.subscribe(value => {
      this.value = value.marketingTouches ? value.marketingTouches : null;
      this.onChange(this.value);
    });
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.form.controls.marketingTouches.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
    isDisabled ? this.form.disable() : this.form.enable()
  }

  removeItem(item: MarketingTouch): void {
    this.markAsTouched();
    this.value = this.value?.filter(i => i.id !== item.id) ?? [];
    this.form.controls.marketingTouches.setValue(this.value);
    this.onChange(this.value);
  }

  valueChange() {
    this.markAsTouched();
    this.onChange(this.value);
  }

  onInputBlur() {
    this.markAsTouched();
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true
    }
  }

}
